import React from 'react';

const updatedOn = 'March 19, 2026';

function PrivacyPage() {
    return (
        <main className="min-h-screen bg-gray-50 px-4 sm:px-6 lg:px-8 py-12">
            <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 lg:p-10">
                <h1 className="text-3xl sm:text-4xl font-semibold text-gray-900 tracking-tight">Privacy Policy</h1>
                <p className="mt-3 text-sm text-gray-500">Last updated: {updatedOn}</p>

                <div className="mt-8 space-y-6 text-sm sm:text-base text-gray-700 leading-relaxed">
                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">1. Information We Collect</h2>
                        <p className="mt-2">
                            We collect account details, communication metadata, and platform usage information needed
                            to operate Kaeros.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">2. How We Use Data</h2>
                        <p className="mt-2">
                            Data is used to deliver features, improve product performance, maintain security,
                            and provide customer support.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">3. Data Sharing</h2>
                        <p className="mt-2">
                            We do not sell personal data. We may share data with infrastructure providers and
                            integrations necessary to run the service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">4. Data Security</h2>
                        <p className="mt-2">
                            We apply technical and operational controls to protect information, though no system can
                            guarantee absolute security.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">5. Contact</h2>
                        <p className="mt-2">
                            For privacy-related questions, use the support or contact channels available in the app.
                        </p>
                    </section>
                </div>
            </div>
        </main>
    );
}

export default PrivacyPage;
